import { useQuery } from "@tanstack/react-query";
import { listPublicCelebrities } from "../api";

/**
 * Read-only roster preview for the opponent circles. Loads for everyone,
 * including signed-out users — the endpoint only returns id/name/image, so
 * no coaching data is exposed before sign-in.
 */
export function usePublicCelebrities() {
  return useQuery({
    queryKey: ["celebrities", "public"],
    queryFn: listPublicCelebrities,
    staleTime: 60_000,
    refetchInterval: 300_000,
  });
}
